import { render, staticRenderFns } from "./PortfolioSummary.vue?vue&type=template&id=36d1063d&scoped=true"
import script from "./PortfolioSummary.vue?vue&type=script&lang=js"
export * from "./PortfolioSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1063d",
  null
  
)

export default component.exports